import { Pencil, UserCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { DataCard, DetailRow } from "@/components/ui/data-card";
import { ConfirmDeleteButton } from "@/components/ui/confirm-delete-button";
import type { Driver, Location } from "@/types/tms";

export type DriverCardDriver = Driver & { home_base?: Location | null };

interface DriverCardProps {
  driver: DriverCardDriver;
  isChecked: boolean;
  onToggle: (id: string) => void;
  onEdit: (driver: Driver) => void;
  onDelete: (id: string) => void;
}

/** Mobile/tablet representation of a driver row on the Drivers page. */
export function DriverCard({ driver, isChecked, onToggle, onEdit, onDelete }: DriverCardProps) {
  return (
    <DataCard>
      <DataCard.Header>
        <span onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={isChecked}
            onCheckedChange={() => onToggle(driver.id)}
            aria-label={`Select ${driver.name}`}
          />
        </span>
        <UserCircle className="h-4 w-4 text-muted-foreground" />
        <span className="font-medium truncate">{driver.name}</span>
        <span className="ml-auto flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
          <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEdit(driver)}>
            <Pencil className="h-4 w-4" />
          </Button>
          <ConfirmDeleteButton
            onConfirm={() => onDelete(driver.id)}
            entityName="driver"
            entityLabel={driver.name}
          />
        </span>
      </DataCard.Header>

      <div className="divide-y divide-border">
        <DetailRow label="Email" value={driver.email || null} />
        <DetailRow label="Slack" value={driver.slack_handle || null} />
        <DetailRow label="Home base" value={driver.home_base?.short_code || null} />
      </div>
    </DataCard>
  );
}